"use client"
import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import LoadingSpinner from "./LoadingSpinner"

export default function AdminGlobalRoute({ children }) {
  const { loading, currentRole, user } = useAuth()
  if (loading) return <LoadingSpinner message="Cargando..." />

  const role = String(currentRole || "").toLowerCase()
  const rolesGlobal = Array.isArray(user?.roles) ? user.roles.map(r => String(r?.nombre || r?.rol || r?.role || r).toLowerCase()) : []

  const globalRoles = ["administrador", "admin", "superadmin"]
  const isGlobalAdmin = role
    ? globalRoles.includes(role)
    : rolesGlobal.some((availableRole) => globalRoles.includes(availableRole))

  if (!isGlobalAdmin) return <Navigate to="/admin" replace />
  return children
}
